'use strict';
import * as $j_app$002elocalization$002e$002dApp$002dLocale$0024 from "./app.localization.-App-Locale$.js";
import * as $j_app$002elocalization$002epackage$0024 from "./app.localization.package$.js";
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$PreCarriageVesselOrFlightNumberForm$() {
  this.aPR = null;
  this.aQ8 = null;
  this.aPU = null;
  this.aPV = false;
  this.aQ0 = null;
  this.aQ1 = false;
  this.aQ6 = null;
  this.aQ7 = false;
  this.aPS = null;
  this.aPT = false;
  this.aQ4 = null;
  this.aQ5 = false;
  this.aQ2 = null;
  this.aQ3 = false;
  this.aPW = null;
  this.aPX = false;
  this.aPY = null;
  this.aPZ = false;
  $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$PreCarriageVesselOrFlightNumberForm$ = this;
  this.aPR = $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$PreCarriageVesselOrFlightNumber$();
  this.aQ8 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lframework_prelude_neotype\uff3fchimney$package$().eU($m_Lapp_data_data\uff3fpoint\uff3ftypes$package$PreCarriageVesselOrFlightNumber$());
}
export { $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$PreCarriageVesselOrFlightNumberForm$ as $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$PreCarriageVesselOrFlightNumberForm$ };
$p = $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$PreCarriageVesselOrFlightNumberForm$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$PreCarriageVesselOrFlightNumberForm$;
/** @constructor */
function $h_Lapp_data_data\uff3fpoint\uff3ftypes$package$PreCarriageVesselOrFlightNumberForm$() {
}
export { $h_Lapp_data_data\uff3fpoint\uff3ftypes$package$PreCarriageVesselOrFlightNumberForm$ as $h_Lapp_data_data\uff3fpoint\uff3ftypes$package$PreCarriageVesselOrFlightNumberForm$ };
$h_Lapp_data_data\uff3fpoint\uff3ftypes$package$PreCarriageVesselOrFlightNumberForm$.prototype = $p;
$p.eR = (function() {
  return this.aPR;
});
$p.eO = (function() {
  return this.aQ8;
});
$p.bW = (function() {
  if ((!this.aPV)) {
    this.aPU = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_CanEqual$derived$();
    this.aPV = true;
  }
  return this.aPU;
});
$p.b9 = (function() {
  if ((!this.aQ1)) {
    this.aQ0 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_utils_UnvalidatedNewtypeOf$$anon$1(this);
    this.aQ1 = true;
  }
  return this.aQ0;
});
$p.b3 = (function() {
  if ((!this.aQ7)) {
    this.aQ6 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_utils_UnvalidatedNewtypeOf$$anon$5(this);
    this.aQ7 = true;
  }
  return this.aQ6;
});
$p.aG = (function() {
  if ((!this.aPT)) {
    this.aPS = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_utils_UnvalidatedNewtypeOf$$anon$6(this);
    this.aPT = true;
  }
  return this.aPS;
});
$p.az = (function() {
  if ((!this.aQ5)) {
    this.aQ4 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lframework_utils_UnvalidatedNewtypeOf__partialTransformer__Lio_scalaland_chimney_PartialTransformer(this);
    this.aQ5 = true;
  }
  return this.aQ4;
});
$p.aY = (function() {
  if ((!this.aQ3)) {
    this.aQ2 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lframework_utils_Validatable$().eS(this.az());
    this.aQ3 = true;
  }
  return this.aQ2;
});
$p.Ji = (function() {
  if ((!this.aPX)) {
    this.aPW = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_localization_LocalizationSupport$$anon$5(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1(((x$1) => {
      var x = $j_app$002elocalization$002e$002dApp$002dLocale$0024.$s_Lapp_localization_AppLocale$__En__Lapp_localization_AppLocale();
      if (((x === null) ? (x$1 === null) : (x === x$1))) {
        return "Pre-Carriage Vessel/Flight Number";
      }
      throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x$1);
    })), $j_app$002elocalization$002epackage$0024.$m_Lapp_localization_package$().cN());
    this.aPX = true;
  }
  return this.aPW;
});
$p.bsl = (function() {
  if ((!this.aPZ)) {
    this.aPY = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lframework_components_TextKindFor$().jx;
    this.aPZ = true;
  }
  return this.aPY;
});
var $d_Lapp_data_data\uff3fpoint\uff3ftypes$package$PreCarriageVesselOrFlightNumberForm$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_data\uff3fpoint\uff3ftypes$package$PreCarriageVesselOrFlightNumberForm$, "app.data.data_point_types$package$PreCarriageVesselOrFlightNumberForm$", ({
  Gn: 1,
  N: 1
}));
export { $d_Lapp_data_data\uff3fpoint\uff3ftypes$package$PreCarriageVesselOrFlightNumberForm$ as $d_Lapp_data_data\uff3fpoint\uff3ftypes$package$PreCarriageVesselOrFlightNumberForm$ };
var $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$PreCarriageVesselOrFlightNumberForm$;
function $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$PreCarriageVesselOrFlightNumberForm$() {
  if ((!$n_Lapp_data_data\uff3fpoint\uff3ftypes$package$PreCarriageVesselOrFlightNumberForm$)) {
    $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$PreCarriageVesselOrFlightNumberForm$ = new $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$PreCarriageVesselOrFlightNumberForm$();
  }
  return $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$PreCarriageVesselOrFlightNumberForm$;
}
export { $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$PreCarriageVesselOrFlightNumberForm$ as $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$PreCarriageVesselOrFlightNumberForm$ };
/** @constructor */
function $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$PreCarriageVesselOrFlightNumber$() {
  this.aPP = null;
  this.aPQ = false;
  this.aPN = null;
  this.aPO = false;
}
export { $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$PreCarriageVesselOrFlightNumber$ as $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$PreCarriageVesselOrFlightNumber$ };
$p = $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$PreCarriageVesselOrFlightNumber$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_Lneotype_Newtype();
$p.constructor = $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$PreCarriageVesselOrFlightNumber$;
/** @constructor */
function $h_Lapp_data_data\uff3fpoint\uff3ftypes$package$PreCarriageVesselOrFlightNumber$() {
}
export { $h_Lapp_data_data\uff3fpoint\uff3ftypes$package$PreCarriageVesselOrFlightNumber$ as $h_Lapp_data_data\uff3fpoint\uff3ftypes$package$PreCarriageVesselOrFlightNumber$ };
$h_Lapp_data_data\uff3fpoint\uff3ftypes$package$PreCarriageVesselOrFlightNumber$.prototype = $p;
$p.aA = (function() {
  if ((!this.aPQ)) {
    this.aPP = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_utils_NewtypeString$$anon$1(this);
    this.aPQ = true;
  }
  return this.aPP;
});
$p.bs3 = (function() {
  if ((!this.aPO)) {
    this.aPN = $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$PreCarriageVesselOrFlightNumberForm$().Ji();
    this.aPO = true;
  }
  return this.aPN;
});
$p.ez = (function(input) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lframework_utils_NewtypeNonEmptyString__validate__T__O(this, input);
});
var $d_Lapp_data_data\uff3fpoint\uff3ftypes$package$PreCarriageVesselOrFlightNumber$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_data\uff3fpoint\uff3ftypes$package$PreCarriageVesselOrFlightNumber$, "app.data.data_point_types$package$PreCarriageVesselOrFlightNumber$", ({
  Gm: 1,
  B: 1,
  C: 1,
  J: 1,
  M: 1
}));
export { $d_Lapp_data_data\uff3fpoint\uff3ftypes$package$PreCarriageVesselOrFlightNumber$ as $d_Lapp_data_data\uff3fpoint\uff3ftypes$package$PreCarriageVesselOrFlightNumber$ };
var $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$PreCarriageVesselOrFlightNumber$;
function $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$PreCarriageVesselOrFlightNumber$() {
  if ((!$n_Lapp_data_data\uff3fpoint\uff3ftypes$package$PreCarriageVesselOrFlightNumber$)) {
    $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$PreCarriageVesselOrFlightNumber$ = new $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$PreCarriageVesselOrFlightNumber$();
  }
  return $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$PreCarriageVesselOrFlightNumber$;
}
export { $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$PreCarriageVesselOrFlightNumber$ as $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$PreCarriageVesselOrFlightNumber$ };
//# sourceMappingURL=app.data.data_point_types$package$-Pre-Carriage-Vessel-Or-Flight-Number$.js.map
